import { setVid } from '../../search-and-filter-schema/protected';
const updateContactFilter = (filters, contact) => {
  return setVid(contact, filters);
};
export default updateContactFilter;